import React, { useState, useEffect } from 'react';
import { Cards, Grid } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import { useGlobalState } from '../../../context/GlobalStateContext';
import Icon from "@cloudscape-design/components/icon";
import { useStoreAdmin } from '../../../context/useStoreAdmin';

const pageSize = 20;

export const ConfigDevicesPage = () => {
  const storeAdmin = useStoreAdmin();
  const { idPropiedad, setIdPropiedad } = useGlobalState();
  const { JWT, setJWT } = useGlobalState(); const { serverVersion, setServerVersion } = useGlobalState(); const { menu, setMenu } = useGlobalState();
  const [loadingMain, setLoadingMain] = useState(false);
  const { setLoading } = useGlobalState();

  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();
  const [devices, setDevices] = useState<DeviceItem[]>([]);

  type Access = {
    idAcceso: string;
    acceso: string;
    idAutorizado: string;
  };

  type DeviceItem = {
    idDevice: number;
    deviceFWVersion: number;
    deviceGMT: number;
    deviceOnline: number;
    deviceMAC: string;
    device: string;
    deviceModel: string;
    deviceHostType: string;
    deviceShadow: any;
  };

  const handleRefresh = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/config/devices/list',
          'JWT': JWT,

        },
        body: JSON.stringify({})
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      storeAdmin(data);

      setDevices(data.devices);

    } catch (error) {
      console.error('Error fetching Devices:', error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    handleRefresh();
  }, []);
  const [
    selectedItems,
    setSelectedItems
  ] = React.useState([{ name: "Item 2" }]);
  return (
    <CustomAppLayout
      toolsHide={true}

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: 'Inicio', href: '#home' },
            { text: 'Configuración', href: '#config/default' },
            { text: 'Dispositivos', href: '#create-transcription-job' },
          ]}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>

          <Cards
            loading={loadingMain}
            //selectionType="single"
            //onSelectionChange={({ detail }) => handleOption(detail.selectedItems[0].id)}
            cardDefinition={{

              header: item => <>
                {item.device}
                <Box float='right'><Icon size='big' name={item.deviceOnline === 1 ? "status-positive" : "status-negative"} variant={item.deviceOnline === 1 ? "normal" : "error"}></Icon></Box>
              </>
              ,
              sections: [
                {
                  header: null, // Remove the header for this combined section
                  content: (item) => (
                    <Grid gridDefinition={[{ colspan: { default: 6 } }, { colspan: { default: 6 } }]}>
                      <div>
                        <b>ID</b>:<br></br> {item.idDevice}
                      </div>
                      <div>
                        <b>Llave</b>:<br></br> {item.deviceMAC}
                      </div>
                    </Grid>
                  ),
                },
                {
                  header: null, // Remove the header for this combined section
                  content: (item) => (
                    <Grid gridDefinition={[{ colspan: { default: 6 } }, { colspan: { default: 6 } }]}>
                      <div>
                        <b>Modelo</b>:<br></br> {item.deviceModel}
                      </div>
                      <div>
                        <b>Versión</b>:<br></br> {item.deviceHostType}-<strong>{item.deviceFWVersion}</strong>
                      </div>
                    </Grid>
                  ),
                },
                {
                  header: "Network",
                  content: (item) => `${item.deviceShadow.ip} / ${item.deviceShadow.gateway} / ${item.deviceShadow.netmask}`,
                },
                {
                  header: "Wifi",
                  content: (item) => `${item.deviceShadow.ssid} (${item.deviceShadow.rssi})`,
                },
                {
                  header: null, // Remove the header for this combined section
                  content: (item) => (
                    <Grid gridDefinition={[{ colspan: { default: 6 } }, { colspan: { default: 6 } }]}>
                      <div>
                        <b>Temp</b>:<br></br> {item.deviceShadow.temp}ºC
                      </div>
                      <div>
                        <b>Hora local</b>:<br></br> {item.deviceShadow.localTime}
                      </div>
                    </Grid>
                  ),
                },
              ],
            }}

            cardsPerRow={
              [{
                minWidth: 600,
                cards: 1
              }, {
                minWidth: 1000,
                cards: 2
              }, {
                minWidth: 1600,
                cards: 3
              }]
            }
            entireCardClickable
            items={devices}
          //header={<Header><Icon name="script"></Icon> Opciones</Header>}
          />
        </>
      }
    />
  );
};
